import { render } from "./ReportCategories.vue?vue&type=template&id=a2ceee0a&scoped=true"
import script from "./ReportCategories.vue?vue&type=script&lang=js"
export * from "./ReportCategories.vue?vue&type=script&lang=js"

import "./ReportCategories.vue?vue&type=style&index=0&id=a2ceee0a&scoped=true&lang=css"
import "./ReportCategories.vue?vue&type=style&index=1&id=a2ceee0a&scoped=true&lang=css"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ceee0a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTabs,QTab,QInput,QIcon,QSeparator,QBanner,QSpinner,QCard,QTable,QField});
